// ############ IMPORTS
// Login and Extras
import Login from "./views/Login/Login.js";
import NoPermission from "./views/Pages/NoPermission.js";
import TermsOfUse from "./views/Extras/TermsOfUse";
import ContactPage from "./views/Extras/ContactPage";

// Admin
import UserManagement from "./views/Admin/UserManagement.js";
import Groups from "./views/Admin/Groups.js";

// Standard Solution Views
import ExecutiveMain from "./views/Executive/ExecutiveMain.js";
import CockpitMain from "./views/Cockpit/CockpitMain.js";
import InputsView from "./views/Inputs/InputsMain.js";

// MUI Icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import VisibilityIcon from "@material-ui/icons/Visibility";
import InputIcon from "@material-ui/icons/Input";
import AdminIcon from "@material-ui/icons/Build";
import CancelIcon from "@material-ui/icons/Cancel";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

// ############ EXTRAS ROUTES INTO MAIN
const extrasRoutes = [
  {
    collapse: true,
    name: "global.components.sidebar.extras",
    icon: MoreHorizIcon,
    state: "ExtrasCollapse",
    layout: "/extras",
    views: [
      {
        path: "/contact",
        name: "global.components.sidebar.extras_menu.contact",
        mini: "global.components.sidebar.extras_menu_mini.contact",
        component: ContactPage,
        layout: "/extras",
      },
      {
        path: "/terms-of-use",
        name: "global.components.sidebar.extras_menu.terms_of_use",
        mini: "global.components.sidebar.extras_menu_mini.terms_of_use",
        component: TermsOfUse,
        layout: "/extras",
      },
      {
        external_link: "https://integrationconsulting.com/en/privacy-policy/",
        name: "global.components.sidebar.extras_menu.privacy_policy",
        mini: "global.components.sidebar.extras_menu_mini.privacy_policy",
        layout: "/extras",
      },
    ],
  },
];

function deepClone(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(deepClone);
  }
  const clonedObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }
  return clonedObj;
}

function changeLayoutToMain(obj) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (key === "layout") {
        obj[key] = "/main";
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        changeLayoutToMain(obj[key]);
      }
    }
  }
}

const extrasRoutesInMain = deepClone(extrasRoutes);
changeLayoutToMain(extrasRoutesInMain);

// ############ MAIN ROUTES
const dashRoutes = [
  {
    // 1. Executive Dashboard
    path: "/executive",
    name: "global.components.sidebar.executive",
    icon: VisibilityIcon,
    layout: "/main",
    component: ExecutiveMain,
    allowedRoles: ["DEV"],
    // allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA"],
  },
  {
    // 2. Cockpit
    path: "/cockpit",
    name: "global.components.sidebar.cockpit",
    icon: DashboardIcon,
    layout: "/main",
    component: CockpitMain,
    allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA"],
  },
  {
    // 3. Inputs Management
    path: "/inputs",
    name: "global.components.sidebar.inputs_management",
    icon: InputIcon,
    layout: "/main",
    component: InputsView,
    allowedRoles: ["DEV", "IMG", "CAD", "CST", "CFA"],
  },
  {
    // 4. Admin
    collapse: true,
    name: "global.components.sidebar.admin",
    icon: AdminIcon,
    state: "AdminCollapse",
    allowedRoles: ["CAD", "IMG", "DEV"],
    layout: "/main",
    views: [
      {
        path: "/user-management",
        name: "global.components.sidebar.admin_menu.user_management",
        mini: "global.components.sidebar.admin_menu_mini.user_management",
        component: UserManagement,
        layout: "/main",
        disabled: false,
      },
      {
        path: "/groups",
        name: "global.components.sidebar.admin_menu.groups",
        mini: "global.components.sidebar.admin_menu_mini.groups",
        component: Groups,
        layout: "/main",
        disabled: false,
        allowedRoles: ["DEV"],
      },
    ],
  },
  {
    // 97. No Permission
    path: "/no-permission",
    name: "global.components.sidebar.no_permission",
    icon: CancelIcon,
    component: NoPermission,
    layout: "/main",
    showOnlyWhenRedirected: true,
  },
  {
    // 98. Login
    path: "/login",
    name: "RGM",
    component: Login,
    layout: "/auth",
  },

  // 99. Extras Routes
  ...extrasRoutes,
  ...extrasRoutesInMain,
];
export default dashRoutes;
